import { LuckySpinsQueryKeys } from '../../queryKeys';
import { useQuery } from '@tanstack/react-query';
import { getLuckySpins } from './service';
import { AxiosError } from 'axios';
import { GenericError } from '@/models/generic-error';
import { LuckySpin } from '@/models/userReward/lucky-spin/lucky-spin';
import { PaginatedResponse } from '@/models/pagination/paginated-response.dto';
import { useEffect } from 'react';
import { UseLuckySpinsProps } from './props';
import { ModalsKey } from '@/enums/modalsKey';
import { useCurrentModal } from '@/hooks/modals/useCurrentModal';
import { useRouter } from 'next/router';
import { usePathname } from '@/hooks/usePathname';
import { useSearchParams } from '@/hooks/useSearchParams';

export function useLuckySpins(options?: UseLuckySpinsProps) {
  const { refetchOnMount = true } = options ?? {};
  const modal: string | undefined = useCurrentModal(ModalsKey);
  const { push } = useRouter();
  const search: URLSearchParams = useSearchParams();
  const pathname: string = usePathname();
  const mode = search.get('mode');

  const { data, error, refetch, isPending } = useQuery<
    PaginatedResponse<LuckySpin>,
    AxiosError<GenericError>
  >({
    queryKey: [LuckySpinsQueryKeys.Primary],
    queryFn: getLuckySpins,
    staleTime: 5 * 1000,
    refetchOnMount,
  });

  function handleDefaultMode() {
    if (!data) {
      return;
    }

    if (!!mode || !modal?.includes(ModalsKey.LuckySpin)) {
      return;
    }

    const searchParams = new URLSearchParams(search);
    searchParams.set('mode', String(data?.data?.[0]?.id));

    push(`${pathname}?${searchParams.toString()}`);
  }

  useEffect(handleDefaultMode, [data, mode, modal, pathname, push, search]);

  return {
    luckySpins: data,
    error,
    refetch,
    isLoading: isPending,
  };
}
